import intlTelInput from 'intl-tel-input';
import spanish from 'intl-tel-input/locale/es';
import 'intl-tel-input/styles';

export default function (input) {
	// In a closed <details> (the application form) the input has no width yet, and the country list takes its width once: set up when it opens.
	const details = input.closest('details:not([open])');

	if (details) {
		details.addEventListener('toggle', () => setUp(input), { once: true });
	} else {
		setUp(input);
	}
}

function setUp(input) {
	const locale = document.documentElement.lang;
	// The country of the browser's language (es-UY, en-GB) when it names one, otherwise Uruguay; Uruguay and Spain, where Dott is, first in the list.
	const region = navigator.language.split('-')[1]?.toLowerCase() ?? '';

	const iti = intlTelInput(input, {
		initialCountry: /^[a-z]{2}$/.test(region) ? region : 'uy',
		countryOrder: ['uy', 'es'],
		countryNameLocale: locale,
		uiTranslations: locale === 'es' ? spanish : {},
		// The example number of the chosen country, over the server's fallback for no JS.
		placeholderNumberPolicy: 'AGGRESSIVE',
		loadUtils: () => import('intl-tel-input/utils'),
	});

	// The number goes in international format, with its country's code, in a hidden field under the input's name: the input keeps showing it without the code, which is next to the flag.
	const number = Object.assign(document.createElement('input'), { type: 'hidden', name: input.name });

	input.removeAttribute('name');
	input.after(number);

	input.form.addEventListener('submit', (event) => {
		const typed = input.value.trim();

		if (typed && iti.isValidNumber() === false) {
			event.preventDefault();
			input.setCustomValidity(input.dataset.invalidError);
			input.reportValidity();
			return;
		}

		// Before the validation script loads, which also formats: the code by hand, and the server validates.
		number.value = !typed ? '' : intlTelInput.utils ? iti.getNumber('INTERNATIONAL') : `+${iti.getSelectedCountry()?.dialCode} ${typed}`;
	});

	for (const type of ['input', 'countrychange']) {
		input.addEventListener(type, () => input.setCustomValidity(''));
	}
}
